import { render, staticRenderFns } from "./EventsHorizontalListWidget.vue?vue&type=template&id=dc811d7a"
import script from "./EventsHorizontalListWidget.vue?vue&type=script&lang=js"
export * from "./EventsHorizontalListWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports